import moment from 'moment';
import { Nullable } from '~globals/types';
import { TransactionMoneyTypes } from '~globals/types/enums';
import { TRACKING_PAGE_URL } from '~constants/commons';

interface PlurarizeParams {
  singular: string;
  plural?: string;
  count?: number;
  includeCount?: boolean;
}

export const pluralize = ({
  singular,
  plural = `${singular}s`,
  count = 0,
  includeCount = false,
}: PlurarizeParams): string => {
  const sentence = count === 1 ? singular : plural;

  return includeCount ? `${count} ${sentence}` : sentence;
};

const getRandomHex = (): string =>
  Math.floor(Math.random() * 256)
    .toString(16)
    .padStart(2, '0');

export const getRandomColor = (): string => {
  let hexColor: string;
  const disabledColors: string[] = ['#ffffff'];

  do {
    const hexRed = getRandomHex();
    const hexGreen = getRandomHex();
    const hexBlue = getRandomHex();

    hexColor = `#${hexRed}${hexGreen}${hexBlue}`;
  } while (disabledColors.includes(hexColor));

  return hexColor;
};

export const getCurrencyType = (moneyType: TransactionMoneyTypes): string =>
  moneyType === TransactionMoneyTypes.ARS ? 'ARS' : 'USD';

export const isEqualArrays = <T>(arr1: T[], arr2: T[]): boolean => {
  if (arr1.length !== arr2.length) return false;

  const sortedArr1 = arr1.slice().sort();
  const sortedArr2 = arr2.slice().sort();

  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false;
    }
  }

  return true;
};

export const openUrlInNewTab = (url: string): Nullable<Window> =>
  window.open(url, '_blank', 'noreferrer');

export const getUrlTrackingCompany = (companyId: string): string =>
  `${TRACKING_PAGE_URL}/company/${companyId}`;

export const getUrlTrackingOrder = (trackingCode: string): string =>
  `${TRACKING_PAGE_URL}/${trackingCode}`;

export const comparateDateToNow = ({
  date,
  comparationType = 'before',
}: {
  date: Nullable<string>;
  comparationType?: 'before' | 'sameOrBefore';
}): boolean => {
  if (date) {
    const now = moment();
    const currentDate = moment(date);

    if (comparationType === 'sameOrBefore') {
      return currentDate.isSameOrBefore(now, 'day');
    }

    return currentDate.isBefore(now, 'day');
  }

  return false;
};

export const createArrayFromNumber = (
  number: number,
  initCero: boolean,
): number[] => Array.from({ length: number }, (_, i) => (initCero ? i : i + 1));
